import React, {useEffect} from 'react';
import {motion} from 'framer-motion';
import {useNavigate} from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {FiActivity, FiArrowRight, FiScissors, FiShield} = FiIcons;

const treatments = [
  {title: 'Weight Loss', path: '/weightquiz', icon: FiActivity, color: 'from-[#0f766e] to-[#14b8a6]', glow: 'group-hover:shadow-teal-500/30'},
  {title: "Men's Health", path: '/menquiz', icon: FiShield, color: 'from-[#075985] to-[#38bdf8]', glow: 'group-hover:shadow-sky-500/30'},
  {title: 'Hair Loss', path: '/hairquiz', icon: FiScissors, color: 'from-[#6d28d9] to-[#c026d3]', glow: 'group-hover:shadow-fuchsia-500/30'}
];

export default function MyTreatments() {
  const navigate = useNavigate();
  useEffect(() => {window.scrollTo(0, 0);}, []);

  return (
    <main className="relative flex min-h-screen items-center overflow-hidden bg-[#effafa] px-4 py-8 sm:px-6 sm:py-12">
      <div className="absolute -left-32 top-12 h-72 w-72 rounded-full bg-teal-200/50 blur-3xl" />
      <div className="absolute -right-24 bottom-0 h-80 w-80 rounded-full bg-cyan-200/50 blur-3xl" />
      <motion.div
        initial={{opacity: 0, y: 20}} animate={{opacity: 1, y: 0}} transition={{duration: 0.55}}
        className="relative mx-auto w-full max-w-6xl overflow-hidden rounded-[2.5rem] border border-white/90 bg-white shadow-2xl shadow-slate-900/10"
      >
        <section className="px-6 py-14 sm:px-10 sm:py-20">
          <div className="mx-auto max-w-3xl text-center">
            <h1 className="text-5xl font-extrabold tracking-tight text-slate-900 sm:text-6xl">Choose your care</h1>
            <p className="mt-5 text-xl font-medium text-slate-600">Select an option to get started.</p>
          </div>
          <div className="mx-auto mt-14 grid max-w-5xl gap-5 md:grid-cols-3">
            {treatments.map((treatment, index) => (
              <motion.button
                key={treatment.path}
                initial={{opacity: 0, y: 20}} animate={{opacity: 1, y: 0}}
                transition={{delay: 0.14 + index * 0.1, duration: 0.45}}
                whileHover={{y: -7}} whileTap={{scale: 0.98}}
                onClick={() => navigate(treatment.path)}
                className={`group relative min-h-[270px] overflow-hidden rounded-[2rem] bg-gradient-to-br ${treatment.color} p-8 text-left text-white shadow-xl transition-all ${treatment.glow}`}
              >
                <div className="absolute -right-10 -top-10 h-36 w-36 rounded-full bg-white/15 transition-transform duration-500 group-hover:scale-150" />
                <div className="relative flex h-full flex-col">
                  <div className="flex h-16 w-16 items-center justify-center rounded-2xl border border-white/25 bg-white/15 backdrop-blur-sm">
                    <SafeIcon icon={treatment.icon} className="h-8 w-8" />
                  </div>
                  <h2 className="mt-8 text-3xl font-extrabold tracking-tight">{treatment.title}</h2>
                  <span className="mt-auto flex items-center gap-3 pt-8 text-lg font-extrabold">
                    Start quiz
                    <SafeIcon icon={FiArrowRight} className="h-6 w-6 transition-transform duration-300 group-hover:translate-x-2" />
                  </span>
                </div>
              </motion.button>
            ))}
          </div>
          <p className="mt-10 text-center text-sm text-slate-400">A licensed clinician determines eligibility and treatment options.</p>
        </section>
      </motion.div>
    </main>
  );
}